module.exports = __webpack_public_path__ + "images/hikakaku_bulk_estimate_text_a20fcadcfb6b8bb9e2a640a3720b51c7.png";